// @ constants
const { parseContracts, mergeInWallet } = require('./brokerCustomWalletParseHelper');
const { BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID } = require('../constants/index');

const getEnabledContracts = contracts => {
    return contracts.filter(contract =>{
        return contract.enabled;
    }).length;
}

const mergeContractInWallet = (state, idPortfolioAccount, contracts, enabledProducts) => {
    return mergeInWallet(state, idPortfolioAccount, (wallet) => {
        let count = wallet.get('count');
        let enabled = false;
        if (idPortfolioAccount === BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID) {
            count = contracts.length;
            enabled = true;
        }

        return wallet.merge({
            contracts: parseContracts(contracts, enabled, enabledProducts),
            count: count,
            alreadyMergedContracts: true,
            isFetching: false
        });
    })
}

const mergeErrorInWallet = (state, idPortfolioAccount, error) => {
    return mergeInWallet(state, idPortfolioAccount, (wallet) => {
        return wallet.merge({
            isFetching: false,
            alreadyMergedContracts: true,
            count: false,
            isCustomWalletContractRequestError: true,
            errorReceived: error,
            isEditable: false
        });
    })
}

const mergeFetchingInWallet = (state, idPortfolioAccount) => {
    return mergeInWallet(state, idPortfolioAccount, (wallet) => {
        return wallet.merge({
            isFetching: true
        });
    })
}

const updatePortfolio = (state, payload) => {
    const { portfolioAccountId, newName, newContracts } = payload;
    const count = getEnabledContracts(newContracts.toJS());

    return mergeInWallet(state, portfolioAccountId, (wallet) => {
        return wallet.merge({
            descriptionPortfolioAccount: newName,
            contracts: newContracts,
            count: count
        });
    })
};

const setPortfolioDefaultView = (state, idPortfolio) => {
    const mappedWallets = state.get('customWallets').map(wallet => {
        if (wallet.get('idPortfolioAccount') === idPortfolio) {
            return wallet.merge({
                defaultView: true
            });
        }

        return wallet;
    });

    return state.merge({
        customWallets: mappedWallets
    });
};

module.exports = {
    mergeContractInWallet,
    mergeErrorInWallet,
    mergeFetchingInWallet,
    updatePortfolio,
    setPortfolioDefaultView
};
